import Vue from 'vue';
import Vuex from 'vuex';
import loadData from './utils/loadData.js';
import isMobile from './utils/isMobile.js';
import alertMessage from './store/modules/alert-message';
import builder from './store/modules/builder';
import formats from './store/modules/formats';
import productSlider from './store/modules/product-slider';

Vue.use(Vuex);

//let SERVICE_URLS = {};
//let domainSLD = (ck.ASSETS_HOST).split('.').pop();
//SERVICE_URLS.CMS = 'https://cms.cardkingdom.'+ domainSLD +':'+ location.port +'/cms';

const state = {
  ...JSON.parse(window.__INITIAL_STATE__),
  loadingStatus: 'uninitiated', //pending,complete,error
  cms: {
    footerMenu: [],
    mainMenu: [],
    promos:  { lightbox: {} },
    heroMenu: []
  },
  products: {},
  userEmail: '',
  cartCount: 0,
  sellCartCount: 0,
  cart: { items: [] },
  sell_cart: { items: [] },
  route: '',
  assetHost: '',
  mainMenuState: {
    showMobileMenu: false,
    showMobileSubMenu: false,
    activeMenuKey: '',
  },
  isMobile: isMobile.get(),
  autoCompleteResults: [],
  errorMessage: ""
};

export const store = new Vuex.Store({
  modules: {
    alertMessage,
    builder,
    formats,
    productSlider,
  },
  state,
  actions:
    {
      initUserEmail() {
        store.commit({
          type: 'saveUserEmail',
          userEmail: ck.userEmail,
        });
      },
      initCartData() {
        let orderServiceTargetUrl = '/api/cart/count?v=' + (new Date().getTime()).toString(24);
        let callback = function (result) {
            store.commit({
                type: 'saveCartCount',
                cartCount: result.count || result,
            });
        }
        loadData.get(orderServiceTargetUrl, callback);
      },
      initSellCartData() {
        let orderServiceTargetUrl = '/api/sellcart/count?v=' + (new Date().getTime()).toString(24);
        let callback = function (result) {
          store.commit({
            type: 'saveSellCartCount',
            sellCartCount: result.count || result,
          });
        }
        loadData.get(orderServiceTargetUrl, callback);
      },
      initCmsData({ commit, state }, payload) {
        const self = this;
        this.state.assetHost = `${ASSETS_HOST}`;
        this.state.cmsHost = `${CMS_HOST}`;
        this.state.route = payload.ck.route;
        let cmsServiceUrl = `${CMS_HOST}/cms/json/ck_config.json?v=${ck.version}`;

        let transformPromoData = function (data) {
          return new Promise(function (resolve, reject) {
            let transformedData = {};
            for (let promoCount = 0, length1 = data.length; promoCount < length1; promoCount++) {
              let selector = (data[promoCount].selector).replace(/\./g, '').replace(/ /g, '_');
              if ((data[promoCount].preview_page).length === 0 || data[promoCount].preview_page === self.state.route) {
                transformedData[selector] = data[promoCount];
              }
            }
            resolve(transformedData);
          });
        };
        if (this.state.loadingStatus === 'uninitiated') {
          this.state.loadingStatus = 'pending';
          return new Promise((resolve) => {
            let cmsSection = payload.section;
            let callback = function (resultData) {
              let transformPromise = transformPromoData(resultData.promos);
              transformPromise.then(function (transformed) {
                resultData.promos = transformed;
                store.commit({
                  type: 'initCms',
                  cmsdata: resultData,
                });
                self.state.loadingStatus = 'complete';
                resolve();
              });
            };
            //if data is undefined or empty set, load data
            if (typeof store.state.cms[cmsSection] === 'undefined' || (typeof store.state.cms[cmsSection] !== 'undefined' && store.state.cms[cmsSection].length < 1)) {
              loadData.get(cmsServiceUrl, callback);
            }
          });
        }
      },
      initAutoComplete({ commit, state }, payload) {
        this.autoCompleteLoadingStatus = this.autoCompleteLoadingStatus || 'uninitiated';
        if (this.autoCompleteLoadingStatus === 'uninitiated' && this.state.autoCompleteResults.length < 1) {
          let autoCompleteUrl = payload.ck.autoCompleteRoute;
          this.autoCompleteLoadingStatus = 'loading';
          let dataReady = (data) => {
            this.state.autoCompleteResults = data;
            this.autoCompleteLoadingStatus = 'ready';
          };
          loadData.get(autoCompleteUrl, dataReady);
        }
      },
    },
  getters: {
    cmsData(state, payload) {
      return state.cms[payload.section];
    },
    userEmail(state) {
      return state.userEmail;
    },
    orderId(state) {
      return state.orderId;
    },
  },
  mutations: {
    setRoute(state, payload) {
      this.state.route = payload.route;
    },
    setEmail(state, payload) {
      this.state.user.email = payload.email;
    },
    initCms(state, payload) {
      this.state.cms = payload.cmsdata;
    },
    setShowMobileMenu(state, payload) {
      this.state.mainMenuState.showMobileMenu = payload;
    },
    setShowMobileSubMenu(state, payload) {
      this.state.mainMenuState.showMobileSubMenu = payload;
    },
    setActiveMenuKey(state, payload) {
      this.state.mainMenuState.activeMenuKey = payload;
    },
    saveCartCount(state, payload) {
      this.state.cartCount = payload.cartCount;
    },
    saveSellCartCount(state, payload) {
      this.state.sellCartCount = payload.sellCartCount;
    },
    saveUserEmail(state, payload) {
      this.state.userEmail = payload.userEmail;
    },
  },
});
